import React, { Component } from "react";
import Proptypes from "prop-types";
import { connect } from "react-redux";
import { Form, FormGroup, Button, Label, Row, Col, CardBody, CardFooter } from "reactstrap";
import {
  renderField,
  required,
  renderTextArea,
  number,
  renderPass,
  json
} from "../../../../utils/formValidations.js";
import { Field, reduxForm } from "redux-form";
import { withRouter } from "react-router-dom";
import TooltipComponent from "../../../../views/Settings/TooltipComponent";



class AwsProviderFormTemplate extends Component {

  constructor(props) {
    super(props);
    this.state = {
      currentProvider: {},
      uploadKeyPair: false,
    };
    this.submitApi = this.submitApi.bind(this);
    this.cancelButton = this.cancelButton.bind(this);
  }


  componentDidMount() {
    if (this.props.current_provider) {
      this.props.initialize({
        vm_provider_config_name: this.props.current_provider.vm_provider_config_name,
        vm_provider_name: this.props.current_provider.vm_provider_name,
        aws_ec2_instance_type: this.props.current_provider.aws_ec2_instance_type,
        aws_region: this.props.current_provider.aws_region,
        aws_access_key_id: this.props.current_provider.aws_access_key_id,
        aws_secret_access_key: this.props.current_provider.aws_secret_access_key,
        aws_ec2_ami_id: this.props.current_provider.aws_ec2_ami_id,
        max_instances: this.props.current_provider.max_instances,
        aws_ec2_security_group_ids: JSON.stringify(this.props.current_provider.aws_ec2_security_group_ids, null, 2),
        aws_ec2_subnet_id: this.props.current_provider.aws_ec2_subnet_id,
        startup_script: this.props.current_provider.startup_script,
        aws_ec2_iam: this.props.current_provider.aws_ec2_iam,
        aws_ec2_ebs_volume_type: this.props.current_provider.aws_ec2_ebs_volume_type,
        aws_ec2_ebs_volume_size_gb: this.props.current_provider.aws_ec2_ebs_volume_size_gb,
        aws_ec2_custom_tags: JSON.stringify(this.props.current_provider.aws_ec2_custom_tags, null, 2),
        aws_ec2_private_key: this.props.current_provider.aws_ec2_private_key,
        aws_ec2_public_key: this.props.current_provider.aws_ec2_public_key,
        aws_ec2_passphrase: this.props.current_provider.aws_ec2_passphrase,
      });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.current_provider && this.props.current_provider !== nextProps.current_provider) {
      this.props.initialize({
        vm_provider_config_name: nextProps.current_provider.vm_provider_config_name,
        vm_provider_name: nextProps.current_provider.vm_provider_name,
        aws_ec2_instance_type: nextProps.current_provider.aws_ec2_instance_type,
        aws_region: nextProps.current_provider.aws_region,
        aws_access_key_id: nextProps.current_provider.aws_access_key_id,
        aws_secret_access_key: nextProps.current_provider.aws_secret_access_key,
        aws_ec2_ami_id: nextProps.current_provider.aws_ec2_ami_id,
        max_instances: nextProps.current_provider.max_instances,
        aws_ec2_security_group_ids: JSON.stringify(nextProps.current_provider.aws_ec2_security_group_ids, null, 2),
        aws_ec2_subnet_id: nextProps.current_provider.aws_ec2_subnet_id,
        startup_script: nextProps.current_provider.startup_script,
        aws_ec2_iam: nextProps.current_provider.aws_ec2_iam,
        aws_ec2_ebs_volume_type: nextProps.current_provider.aws_ec2_ebs_volume_type,
        aws_ec2_ebs_volume_size_gb: nextProps.current_provider.aws_ec2_ebs_volume_size_gb,
        aws_ec2_custom_tags: JSON.stringify(nextProps.current_provider.aws_ec2_custom_tags, null, 2),
        aws_ec2_private_key: nextProps.current_provider.aws_ec2_private_key,
        aws_ec2_public_key: nextProps.current_provider.aws_ec2_public_key,
        aws_ec2_passphrase: nextProps.current_provider.aws_ec2_passphrase,
      });
    }
  }

  downloadBlob() {
    let jsonBlob = new Blob([this.state.aws_ec2_public_key]);
    const blobUrl = URL.createObjectURL(jsonBlob);

    const link = document.createElement("a");

    link.href = blobUrl;
    link.download = 'id_rsa.pub';

    document.body.appendChild(link);

    link.dispatchEvent(
      new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window
      })
    );
    document.body.removeChild(link);
  };


  cancelButton() {
    this.props.cancel_button(userData)
  }

  submitApi(userData) {
    userData.vm_provider_name = "aws"
    this.props.submit_api(userData)
  }

  render() {
    const { handleSubmit } = this.props;
    const { currentZone } = this.state;

    return (
      <Form onSubmit={handleSubmit(this.submitApi)}>
        <CardBody>
          <React.Fragment>
            <FormGroup>
              <Row>
                <Col>
                  <Label htmlFor="vm_provider_config_name" className="requiredasterisk">Name </Label>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Field type="text"
                    name="vm_provider_config_name"
                    id="vm_provider_config_name"
                    component={renderField}
                    validate={required}
                    placeholder="Example AWS Config"
                  />
                </Col>
              </Row>
            </FormGroup>

            <FormGroup>
              <Row>
                <Col>
                  <Label htmlFor="aws_access_key_id" className="requiredasterisk">AWS Access Key Id</Label>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Field type="text"
                    name="aws_access_key_id"
                    id="aws_access_key_id"
                    component={renderField}
                    validate={required}
                  />
                </Col>
              </Row>
            </FormGroup>
            <FormGroup>
              <Row>
                <Col>
                  <Label htmlFor="aws_secret_access_key" className="requiredasterisk">AWS Secret Access Key</Label>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Field type="password"
                    name="aws_secret_access_key"
                    id="aws_secret_access_key"
                    component={renderPass}
                    validate={required}
                  />
                </Col>
              </Row>
            </FormGroup>
            <FormGroup>
              <Row>
                <Col>
                  <Label htmlFor="aws_region" className="requiredasterisk">AWS Region</Label>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Field type="text"
                    name="aws_region"
                    id="aws_region"
                    component={renderField}
                    validate={required}
                    placeholder="us-east-1"
                  />
                </Col>
              </Row>
            </FormGroup>
            <FormGroup>
              <Row>
                <Col>
                  <Label htmlFor="aws_ec2_ami_id" className="requiredasterisk">AWS: EC2 AMI Id</Label>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Field type="text"
                    name="aws_ec2_ami_id"
                    id="aws_ec2_ami_id"
                    component={renderField}
                    validate={required}
                  />
                </Col>
              </Row>
            </FormGroup>
            <FormGroup>
              <Row>
                <Col>
                  <Label htmlFor="aws_ec2_instance_type" className="requiredasterisk">AWS: EC2 Instance Type</Label>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Field
                    name="aws_ec2_instance_type"
                    id="aws_ec2_instance_type"
                    component={renderField}
                    validate={required}
                    autoComplete='random-string'
                    placeholder="t3.micro"
                  />
                </Col>
              </Row>
            </FormGroup>
            <FormGroup>
              <Row>
                <Col>
                  <Label htmlFor="max_instances" className="requiredasterisk">AWS Max EC2 Nodes</Label>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Field name="max_instances"
                    id="max_instances"
                    component={renderField}
                    validate={number}
                  />
                </Col>
              </Row>
            </FormGroup>
            <FormGroup>
              <Row>
                <Col>
                  <Label htmlFor="aws_ec2_security_group_ids" className="requiredasterisk">AWS: EC2 Security Group IDs (JSON)</Label>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Field type="textarea"
                    name="aws_ec2_security_group_ids"
                    id="aws_ec2_security_group_ids"
                    component={renderTextArea}
                    validate={[required, json]}
                    placeholder='["sg-xyx", "sg-123"]'
                  />
                </Col>
              </Row>
            </FormGroup>
            <FormGroup>
              <Row>
                <Col>
                  <Label htmlFor="aws_ec2_subnet_id" className="requiredasterisk">AWS: EC2 Subnet ID</Label>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Field type="text"
                    name="aws_ec2_subnet_id"
                    id="aws_ec2_subnet_id"
                    component={renderField}
                    validate={required}
                  />
                </Col>
              </Row>
            </FormGroup>
            <FormGroup>
              <Row>
                <Col>
                  <Label htmlFor="aws_ec2_ebs_volume_size_gb" className="requiredasterisk">AWS: EC2 EBS Volume Size (GB)</Label>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Field type="number"
                    name="aws_ec2_ebs_volume_size_gb"
                    id="aws_ec2_ebs_volume_size_gb"
                    component={renderField}
                    validate={number}
                  />
                </Col>
              </Row>
            </FormGroup>
            <FormGroup>
              <Row>
                <Col>
                  <Label htmlFor="aws_ec2_ebs_volume_type" className="requiredasterisk">AWS: EC2 EBS Volume Type</Label>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Field type="text"
                    name="aws_ec2_ebs_volume_type"
                    id="aws_ec2_ebs_volume_type"
                    component={renderField}
                    validate={required}
                  />
                </Col>
              </Row>
            </FormGroup>
            <FormGroup>
              <Row>
                <Col>
                  <Label htmlFor="aws_ec2_iam" className="requiredasterisk">AWS: EC2 IAM</Label>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Field type="text"
                    name="aws_ec2_iam"
                    id="aws_ec2_iam"
                    component={renderField}
                    validate={required}
                  />
                </Col>
              </Row>
            </FormGroup>
            <FormGroup>
              <Row>
                <Col>
                  <Label htmlFor="aws_ec2_custom_tags" className="requiredasterisk whitespacePre">AWS: EC2 Custom Tags (JSON)</Label>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Field type="text"
                    name="aws_ec2_custom_tags"
                    id="aws_ec2_custom_tags"
                    component={renderTextArea}
                    validate={[required, json]}
                    placeholder="{}"

                  />
                </Col>
              </Row>
            </FormGroup>
            <FormGroup>
              <Row>
                <Col>
                  <Label htmlFor="startup_script" className="requiredasterisk whitespacePre">AWS: EC2 Startup Script</Label>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Field type="textarea"
                    name="startup_script"
                    id="startup_script"
                    component={renderTextArea}
                    validate={required}
                  />
                </Col>
              </Row>
            </FormGroup>

            <FormGroup>
              <Row>
                <Col>
                  <Label htmlFor="startup_script" className="requiredasterisk whitespacePre">SSH Keys</Label>
                </Col>
              </Row>
              <Row>
                <Col>
                  {this.state.aws_ec2_public_key && (
                    <div style={{ marginTop: '15px' }}>
                      <TooltipComponent
                        description="The SSH Public key that is used by AWS when provisioning VMs"
                        name={(
                          <Button className="btn-width download-btn" size="md" color="success" onClick={this.downloadBlob}>
                            <i className="fa fa-download" aria-hidden="true"></i>{" "}Download Public Key
                          </Button>
                        )}
                      />
                    </div>

                  )}
                  <div style={{ marginTop: '15px' }}>
                    <TooltipComponent
                      description="Update the SSH key pair that is used for authentication by AWS when provisioning VMs."
                      name={(
                        <Button className="btn-width download-btn" size="md" color="success" onClick={() => this.setState({ uploadKeyPair: !this.state.uploadKeyPair })}>
                          <i className="fa fa-upload" aria-hidden="true"></i>{" "}Upload New Key Pair
                        </Button>
                      )}
                    />
                  </div>
                </Col>
              </Row>

              {this.state.uploadKeyPair && (
                <React.Fragment>
                  <p style={{ marginTop: '15px' }}>Enter the private key below and the passphrase for the key if required. The public key will be extracted from the private key. The passhrpase is not stored.</p>
                  <Row>
                    <Col>
                      <Label htmlFor="aws_ec2_private_key" className="requiredasterisk whitespacePre">SSH Private Key (Type: RSA, Format: PEM)</Label>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Field type="textarea"
                        name="aws_ec2_private_key"
                        id="aws_ec2_private_key"
                        component={renderTextArea}
                        validate={required}
                        placeholder="-----BEGIN RSA PRIVATE KEY-----&#10;...&#10;-----END RSA PRIVATE KEY-----"
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <label>SSH Private Key Passphrase</label>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Field
                        id="aws_ec2_passphrase"
                        type="aws_ec2_passphrase"
                        name="aws_ec2_passphrase"
                        component={renderField}
                      />
                    </Col>
                  </Row>

                </React.Fragment>
              )}


            </FormGroup>


          </React.Fragment>
        </CardBody>
        <CardFooter>
          <FormGroup className="form-actions">
            <Button type="button" size="sm"
              className="cancel-button"
              color="basic" onClick={() => this.props.cancel_button()}>{ this.props.wizard ? 'Previous' : 'Cancel'}</Button>
            <Button type="submit"
              className="submit-button"
              size="sm" color="primary">{!this.props.wizard ? 'Submit' : this.props.stepCount && this.props.stepCount > 2 ? 'Next' : 'Finish'}</Button>
          </FormGroup>
        </CardFooter>
      </Form>
    );
  }
}


AwsProviderFormTemplate.propTypes = {
  current_provider: Proptypes.object,
  submit_api: Proptypes.func.isRequired,
  handleSubmit: Proptypes.func,
  cancel_button: Proptypes.func,
};


let AwsProviderFormWithRouter = withRouter(AwsProviderFormTemplate);

let AwsProviderForm = connect(state => {

  return {
    vm_provider_configs: state.vm_provider.vm_provider_configs,
  }
},

  dispatch =>
  ({

  }))(AwsProviderFormWithRouter);

export default reduxForm({
  form: "VmProviderForm",
})(AwsProviderForm);
